import { FC, ReactNode } from 'react';
import {
  Skeleton,
  TextSkeleton,
} from '../../../../../packages/ui/components/skeleton';

export const SuperstarLayout: FC<{
  image: ReactNode;
  title: ReactNode;
  nickName: ReactNode;
  tier: ReactNode;
}> = ({ image, title, nickName, tier }) => {
  return (
    <div className="bg-back300 rounded-md px-5 py-10">
      <div className="relative aspect-[1220/1600] overflow-hidden">{image}</div>
      {tier}
      {title}
      {nickName}
    </div>
  );
};

export const SuperstarSkeleton = () => {
  return (
    <SuperstarLayout
      image={<Skeleton className="absolute inset-0" />}
      title={
        <div className="flex justify-center">
          <TextSkeleton fontSize={16} lineHeight={24} className="w-20" />
        </div>
      }
      nickName={
        <div className="flex justify-center">
          <TextSkeleton fontSize={14} lineHeight={21} className="w-24" />
        </div>
      }
      tier={
        <div className="flex justify-center">
          <Skeleton className="h-5 w-[140px]" />
        </div>
      }
    />
  );
};

export const SuperstarListLayout = ({ children, pagination }) => {
  return (
    <div className="flex flex-col gap-10">
      <div className="3xl:grid-cols-5 grid grid-cols-1 gap-5 md:grid-cols-3">
        {children}
      </div>
      <div className="mt-5">{pagination}</div>
    </div>
  );
};

export const SuperstarPageLayout: FC<{
  searchInput: ReactNode;
  filter: ReactNode;
  children: ReactNode;
}> = ({ filter, searchInput, children }) => {
  return (
    <div className="flex flex-col gap-5">
      <div className="pb-4 text-xl font-medium">Superstar Guide</div>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        <div className="col-span-1 flex gap-5 md:col-span-2">{searchInput}</div>
        <div className="col-span-1">{filter}</div>
      </div>
      {children}
    </div>
  );
};

export const SuperstarPageSkeleton = () => {
  return (
    <SuperstarPageLayout
      searchInput={<Skeleton className="w-full" style={{ height: 46 }} />}
      filter={<Skeleton className="w-full" style={{ height: 46 }} />}
    >
      <SuperstarListLayout pagination={<Skeleton className="w-full" />}>
        {new Array(15).fill(0).map((_, index) => (
          <SuperstarSkeleton key={index} />
        ))}
      </SuperstarListLayout>
    </SuperstarPageLayout>
  );
};
